import { AxiosResponse } from 'axios/index';
// import config from '@app/config';

export function handleResponse<T>(response: AxiosResponse<any, { data: T }>) {
  // if (config.environment !== 'PRODUCTION') {
  //   console.log(response.data);
  //   console.log(response.status);
  //   console.log(response.statusText);
  //   console.log(response.headers);
  //   console.log(response.config);
  // }
  if (response.data?.data !== undefined) {
    return response.data?.data;
  }

  return response.data;
}
